import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mb-5 position-relative d-flex align-items-center justify-content-center",
  style: {
      height: '765px',
      width: 'calc(100% + 12%)',
      marginLeft: '-6%',
      marginRight: '-6%',
      marginTop: '-6%',
      backgroundImage: 'var(--frame-report-bg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }
}
const _hoisted_2 = { class: "row w-100 px-5" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = {
  class: "text-white mb-4",
  style: {"font-size":"36px","line-height":"1.2","max-width":"100%","white-space":"pre-line"}
}
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = {
  class: "text-white",
  style: {"font-size":"20px","line-height":"1.2"}
}
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = {
  class: "position-relative h-100",
  style: {"min-height":"200px","width":"100%","margin":"0 auto"}
}
const _hoisted_10 = {
  key: 0,
  class: "text-white mt-2",
  style: {"font-size":"12px","line-height":"1.4"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewCanvasComponent = _resolveComponent("PreviewCanvasComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "mb-4",
            style: {"max-width":"200px","height":"50px","margin-bottom":"200px !important","background-image":"var(--logo-image-white)","background-size":"contain","background-repeat":"no-repeat","background-position":"left"}
          }, null, -1)),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t(`project.previewAndReport.reportTypes.title`)), 1),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "bg-white mb-4",
            style: {"height":"1px","width":"80%"}
          }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.projectData?.project_name || "N/A"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.includeSections.screenshot)
            ? (_openBlock(), _createBlock(_component_PreviewCanvasComponent, { key: 0 }, {
                footer: _withCtx(() => [
                  (_ctx.resolvedNoteText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.resolvedNoteText), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}